import { left, right } from '@sweet-monads/either';
import type { Either } from '@sweet-monads/either';

import { AbstractError } from '@/domain/errors/abstract-error.js';
import { ServerError } from '@/domain/errors/server-error.js';
import type { ThemeColors } from '@/domain/models/theme.js';
import type { DefaultThemeResult, ThemeRepository } from '@/domain/repositories/theme-repository.js';
import type { GetDefaultTheme, UpdateDefaultTheme } from '@/domain/use-cases/theme.js';

export class GetDefaultThemeUseCase implements GetDefaultTheme {
    constructor(private readonly repository: ThemeRepository) {}

    public async execute(): Promise<Either<AbstractError, DefaultThemeResult>> {
        try {
            return right(await this.repository.getDefaultTheme());
        } catch (error) {
            if (error instanceof AbstractError) {
                return left(error);
            }
            return left(new ServerError((error as Error).message));
        }
    }
}

export class UpdateDefaultThemeUseCase implements UpdateDefaultTheme {
    constructor(private readonly repository: ThemeRepository) {}

    public async execute(colors: ThemeColors): Promise<Either<AbstractError, { colors: ThemeColors }>> {
        try {
            return right(await this.repository.updateDefaultTheme(colors));
        } catch (error) {
            if (error instanceof AbstractError) {
                return left(error);
            }
            return left(new ServerError((error as Error).message));
        }
    }
}
